/** @jsx jsx */
import { jsx } from 'theme-ui'
import { shape, bool, string, arrayOf, number, func } from 'prop-types'
import { useEffect, useState } from 'react'

import { useFormikContext } from 'formik'
import { QuestionVisible } from './form/InputValidationHelper'
import HiddenQuestion from './HiddenQuestion'
import QuestionSectionContent from './QuestionSectionContent'

const QuestionSection = ({
  question,
  isStrategyBuilderQuestion,
  hideAllRequiredMessage,
  setFormValues,
  questionHasTooManyAnswers,
  setQuestionHasTooManyAnswers,
  hideTitle = false,
  ...props
}) => {
  const { values, setFieldValue } = useFormikContext()

  const [showQuestion, setShowQuestion] = useState(true)
  //Question visibility based on answers to another question
  useEffect(() => {
    setShowQuestion(QuestionVisible(question, values))
  }, [question, values])

  return (
    <HiddenQuestion
      state={!showQuestion}
      question={question}
      values={values}
      isStrategyBuilderQuestion={isStrategyBuilderQuestion}
    >
      <QuestionSectionContent
        values={values}
        setFieldValue={setFieldValue}
        showQuestion={showQuestion}
        question={question}
        isStrategyBuilderQuestion={isStrategyBuilderQuestion}
        hideAllRequiredMessage={hideAllRequiredMessage}
        setFormValues={setFormValues}
        questionHasTooManyAnswers={questionHasTooManyAnswers}
        setQuestionHasTooManyAnswers={setQuestionHasTooManyAnswers}
        hideTitle={hideTitle}
        {...props}
      />
    </HiddenQuestion>
  )
}

QuestionSection.propTypes = {
  question: shape({
    answers: arrayOf(
      shape({
        answerType: string,
        id: string,
        order: number,
        // when empty placeHolder is null
        placeHolder: string,
        text: string,
      })
    ),
    id: string,
    subText: string,
    text: string,
  }).isRequired,
  setQuestionHasTooManyAnswers: func,
  questionHasTooManyAnswers: bool,
  isStrategyBuilderQuestion: bool,
  hideAllRequiredMessage: bool,
  setFormValues: func,
  hideTitle: bool,
}

export default QuestionSection
